/*
fetch-bonuses.js
*/

import actions from '../../common/lib/utils/actions.js';
import constants from '../../common/lib/utils/constants.js';
import core from '../../common/lib/core.js';
import dataflow from '../../common/lib/dataflow.js';
import view from './view.js';

const register = dataflow.register;
const state = {
	/* list of bonusobject */
	list: null,
	pending: false
};
let requestUrl;
let callbackIfEmpty = null;

function viewUpdate() {
	view.update({
		fetch_bonuses: state
	});
}

function parseToState(data, freeMoneyBonusSuccess) {
	const successful = Boolean((data && data.status) && (data.status.toLowerCase && data.status.toLowerCase() === 'success'));
	const result = Boolean(data && (data.result && Array.isArray(data.result)));
	const successfulResult = Boolean(successful && result);
	if (successfulResult) {
		state.list = data.result;
		if (freeMoneyBonusSuccess){
			actions.fetchBonusesFreeMoneyBonusSuccess(state);
		} else {
			actions.fetchBonuses(state);
		}
	} else {
		console.error('fetch_bonuses:parseToState:46:can not read data:', data);
	}
	return successfulResult;
}

function parseToStateForShopDepositBonus(data, selectedBonusId, bonusPaymentMethods) {
	if (data) {
		if (data.status && data.status.toLowerCase() === 'success') {
			if (data.result) {
				if (Array.isArray(data.result)) {
					state.list = data.result;
					actions.fetchBonusesForShopDeposit(state, selectedBonusId, bonusPaymentMethods);
				}
			}
		}
	} else {
		console.error('Error in retrieved bonus data', data);
	}
}

function getDataAndReplaceState(freeMoneyBonusSuccess) {
	state.pending = false;
	const successHandler = function successHandler(data) {
		const bonusExist = parseToState(data, freeMoneyBonusSuccess);
		// Skipping to deposit action if there are no available bonuses
		if (!bonusExist) {
			callbackIfEmpty();
		}
		viewUpdate();
	};
	const failHandler = function failHandler(err) {
		viewUpdate();
		console.error('fetch_bonuses:getDataAndReplaceState:67:failHandler:', err);
	};
	core.get(requestUrl, successHandler, failHandler);
}

function getDataAndReplaceStateForShopDepositBonus(selectedBonusId, bonusPaymentMethods) {
	const successHandler = function successHandler(data) {
		parseToStateForShopDepositBonus(data, selectedBonusId, bonusPaymentMethods);
	};
	const failHandler = function failHandler(err) {
		if (err.status && err.status === 500) {
			console.warn('log in before sending request.', err);
		} else {
			console.error('error:', err);
		}
	};
	core.get(requestUrl, successHandler, failHandler);
}

function registerActions() {
	function fetchBonuses(payload) {
		if (payload.type === constants.SETUP_BONUS) {
			state.pending = true;
			viewUpdate();
			getDataAndReplaceState();
		}
		if (payload.type === constants.SHOP_HANDLE_BONUS_FOR_DEPOSIT) {
			// viewUpdate(); -- why do we need a view update?
			getDataAndReplaceStateForShopDepositBonus(payload.data.selectedBonusId, payload.data.bonusPaymentMethods);
		}
		if (payload.type === constants.RELOAD_BONUSES_FREE_MONEY_BONUS_SUCCESS) {
			getDataAndReplaceState(true);
		}
	}
	register(fetchBonuses);
}

export default {
	init(url, isEmptyCallback) {
		/* the init method prepares the module to respond to the actions and attach the provided urls. */
		if (url) {
			requestUrl = url;
			callbackIfEmpty = ((typeof isEmptyCallback === 'function') ? isEmptyCallback : function doNothing() {});
		} else {
			console.error('init: no url provided', url);
		}
		registerActions();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/bonus/lib/fetch-bonuses.js